import { WebserviceUrl } from "@tm/data/webserviceUrls"
import { ajaxAuth } from "@tm/utils"
import { DeleteBackorderRequest, DeleteBackorderResponse } from "./models"

export function deleteBackorder(body: DeleteBackorderRequest): Promise<DeleteBackorderResponse | undefined> {
    const url = `${WebserviceUrl.CisBackorders}/DeleteBackorder`
    return ajaxAuth({ url, body, method: "POST" })
}
